import { c as _c } from "react/compiler-runtime";
import { businessDiToFormData, isURL } from '@onefootprint/core';
import type { CollectedDataOption, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { StepUpContext } from '@/idv2/hooks/use-step-up';
import { CORPORATION_TYPE_OPTIONS } from '../utils/constants';
import { TinRevealField } from './tin-reveal-field';
type BasicDataFieldsProps = {
  attributes: CollectedDataOption[];
  locale: Locale;
  isTinScrubbed?: boolean;
  authToken: string;
  stepUpContext: StepUpContext;
};
export const BasicDataFields = t0 => {
  const $0 = _c(38);
  const {
    attributes,
    locale,
    isTinScrubbed,
    authToken,
    stepUpContext
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectBusinessData.fields"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($0[1] !== attributes) {
    t2 = attributes.includes("business_name");
    $0[1] = attributes;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  const showName = t2;
  let t3;
  if ($0[3] !== attributes) {
    t3 = attributes.includes("business_tin");
    $0[3] = attributes;
    $0[4] = t3;
  } else {
    t3 = $0[4];
  }
  const showTin = t3;
  let t4;
  if ($0[5] !== attributes) {
    t4 = attributes.includes("business_corporation_type");
    $0[5] = attributes;
    $0[6] = t4;
  } else {
    t4 = $0[6];
  }
  const showCorporationType = t4;
  let t5;
  if ($0[7] !== attributes) {
    t5 = attributes.includes("business_website");
    $0[7] = attributes;
    $0[8] = t5;
  } else {
    t5 = $0[8];
  }
  const showWebsite = t5;
  let t6;
  if ($0[9] !== attributes) {
    t6 = attributes.includes("business_phone_number");
    $0[9] = attributes;
    $0[10] = t6;
  } else {
    t6 = $0[10];
  }
  const showPhoneNumber = t6;
  let t7;
  if ($0[11] !== t) {
    t7 = CORPORATION_TYPE_OPTIONS.map(option => ({
      value: option.value,
      label: t($ => $.corporationType.options[option.value])
    }));
    $0[11] = t;
    $0[12] = t7;
  } else {
    t7 = $0[12];
  }
  const corporationTypeOptions = t7;
  let t8;
  if ($0[13] !== showName || $0[14] !== t) {
    t8 = showName && <><Form.Input name={businessDiToFormData("business.name")} data-dd-privacy="mask" autoFocus={true} label={t(_temp)} placeholder={t(_temp2)} rules={{
        required: t(_temp3)
      }} /><Form.Input name={businessDiToFormData("business.dba")} data-dd-privacy="mask" label={t(_temp4)} placeholder={t(_temp5)} /></>;
    $0[13] = showName;
    $0[14] = t;
    $0[15] = t8;
  } else {
    t8 = $0[15];
  }
  let t9;
  if ($0[16] !== authToken || $0[17] !== isTinScrubbed || $0[18] !== showTin || $0[19] !== stepUpContext) {
    t9 = showTin && <TinRevealField isScrubbed={isTinScrubbed ?? false} authToken={authToken} stepUpContext={stepUpContext} />;
    $0[16] = authToken;
    $0[17] = isTinScrubbed;
    $0[18] = showTin;
    $0[19] = stepUpContext;
    $0[20] = t9;
  } else {
    t9 = $0[20];
  }
  let t10;
  if ($0[21] !== corporationTypeOptions || $0[22] !== showCorporationType || $0[23] !== t) {
    t10 = showCorporationType && <Form.Select name={businessDiToFormData("business.corporation_type")} data-dd-privacy="mask" label={t(_temp6)} placeholder={t(_temp7)} options={corporationTypeOptions} rules={{
      required: t(_temp8)
    }} />;
    $0[21] = corporationTypeOptions;
    $0[22] = showCorporationType;
    $0[23] = t;
    $0[24] = t10;
  } else {
    t10 = $0[24];
  }
  let t11;
  if ($0[25] !== showWebsite || $0[26] !== t) {
    t11 = showWebsite && <Form.Input name={businessDiToFormData("business.website")} data-dd-privacy="mask" label={t(_temp9)} placeholder={t(_temp10)} rules={{
      required: t(_temp11),
      validate: value => {
        if (!value) {
          return true;
        }
        if (!isURL(value)) {
          return t(_temp12);
        }
        return true;
      }
    }} />;
    $0[25] = showWebsite;
    $0[26] = t;
    $0[27] = t11;
  } else {
    t11 = $0[27];
  }
  let t12;
  if ($0[28] !== locale || $0[29] !== showPhoneNumber || $0[30] !== t) {
    t12 = showPhoneNumber && <Form.Tel name={businessDiToFormData("business.phone_number")} data-dd-privacy="mask" label={t(_temp13)} locale={locale} rules={{
      required: t(_temp14)
    }} />;
    $0[28] = locale;
    $0[29] = showPhoneNumber;
    $0[30] = t;
    $0[31] = t12;
  } else {
    t12 = $0[31];
  }
  let t13;
  if ($0[32] !== t10 || $0[33] !== t11 || $0[34] !== t12 || $0[35] !== t8 || $0[36] !== t9) {
    t13 = <div className="flex flex-col gap-6 w-full">{t8}{t9}{t10}{t11}{t12}</div>;
    $0[32] = t10;
    $0[33] = t11;
    $0[34] = t12;
    $0[35] = t8;
    $0[36] = t9;
    $0[37] = t13;
  } else {
    t13 = $0[37];
  }
  return t13;
};
function _temp($_0) {
  return $_0.businessName.label;
}
function _temp2($_1) {
  return $_1.businessName.placeholder;
}
function _temp3($_2) {
  return $_2.businessName.error;
}
function _temp4($_3) {
  return $_3.dba.label;
}
function _temp5($_4) {
  return $_4.dba.placeholder;
}
function _temp6($_5) {
  return $_5.corporationType.label;
}
function _temp7($_6) {
  return $_6.corporationType.placeholder;
}
function _temp8($_7) {
  return $_7.corporationType.error;
}
function _temp9($_8) {
  return $_8.website.label;
}
function _temp10($_9) {
  return $_9.website.placeholder;
}
function _temp11($_10) {
  return $_10.website.errors.required;
}
function _temp12($_11) {
  return $_11.website.errors.invalid;
}
function _temp13($_12) {
  return $_12.phoneNumber.label;
}
function _temp14($_13) {
  return $_13.phoneNumber.errors.required;
}